import { apiClient } from './client'
import type { RecentAlertsResponse } from '../types/alerts'

const BASE_PATH = '/api/alerts'

export interface RecentAlertsParams {
  days?: number
  limit?: number
}

export const alertsApi = {
  getRecent: async (params?: RecentAlertsParams): Promise<RecentAlertsResponse> => {
    const response = await apiClient.get<RecentAlertsResponse>(
      `${BASE_PATH}/recent`,
      { params }
    )
    return response.data
  },
}
